import React from 'react';
import { withAssetPrefix } from 'gatsby';
import { Helmet } from 'react-helmet';
import { useIntl } from 'gatsby-plugin-intl';
import Layout from '../../components/layout';
import PageContentExpresso from '../../components/PageContentExpresso';
import ImgCatalogoImpressao from '../../images/imagem-impressao-1c-e1563384096971.jpg';
import ImgShulzs from '../../images/shulzs-e1563383994314.png';
import ImgTimerr from '../../images/timerr-e1563816960984.jpg';
import ImgSpeed from '../../images/speed-2-e1563383755708.jpg';
import ImgBook from '../../images/book-e1563817421226.jpg';
import ImgCorte from '../../images/corte-e1563817839100.jpg';
import ImgBrowser from '../../images/browser-e1563379327936.jpg';
import ImgPdf from '../../images/pdf-impresso-e1563818047437.jpg';
import ImgCatImpresso from '../../images/catalogo-impress-e1563383910760.jpg';

export default ({ location }) => {
  const intl = useIntl();

  return (
    <Layout location={location}>
      <Helmet bodyAttributes={{ class: 'page-template page-template-page-expresso page-template-page-expresso-php page page-id-463 full-width custom-font-enabled single-author mob-menu-slideout' }}>
        <title>{intl.formatMessage({ id: 'Catálogo Impresso | Ideia 2001' })}</title>
      </Helmet>

      <div id="primary" className="site-content">
        <PageContentExpresso
          titulo={intl.formatMessage({ id: 'Catálogo Impresso' })}
          Conteudo={() => (
            <>
              <h2 className="tituloProdutoInterno2">{intl.formatMessage({ id: 'Módulo de Impressão' })}</h2>
              <p>{intl.formatMessage({ id: 'É o gerador automático do Catálogo Impresso da sua empresa, em minutos seu Catálogo Impresso está pronto para imprimir na gráfica' })}.</p>
              <div style={{ width: '100%', textAlign: 'center' }}><img className="alignnone wp-image-471 size-full" src={ImgCatalogoImpressao} alt={intl.formatMessage({ id: 'Imagem catálogo impresso' })} width="1035" height="679" srcSet={`${withAssetPrefix('images/imagem-impressao-1c-e1563384096971.jpg')} 1035w, ${withAssetPrefix('images/imagem-impressao-1c-e1563384096971-1024x672.jpg')} 1024w, ${withAssetPrefix('images/imagem-impressao-1c-e1563384096971-768x504.jpg')} 768w, ${withAssetPrefix('images/imagem-impressao-1c-e1563384096971-624x409.jpg')} 624w`} sizes="(max-width: 1035px) 100vw, 1035px" /></div>
              <div className="col-lg-12 text-center">
                <h3>{intl.formatMessage({ id: 'O Módulo de Impressão' })}</h3>
                <p>{intl.formatMessage({ id: 'A ideia é que o Módulo de Impressão seja uma solução definitiva para geração do seu Catálogo Impresso, isto é, com apenas um clique você gera um arquivo PDF pronto para imprimir, disponibilizar no site ou enviar diretamente para o seu cliente' })}.</p>
                <h3 style={{ marginTop: 30 }}>{intl.formatMessage({ id: 'O Catálogo Impresso' })}</h3>
                <p>{intl.formatMessage({ id: 'O catálogo gerado é completo, com capas, mídias intermediárias, índices e miolos' })}.</p>
              </div>
              <section className="fundoCinzaInterno">
                <div className="container produtosInterno">
                  <div className="row">
                    <div className="col-lg-12 text-center"><img className="alignnone wp-image-478 size-full" src={ImgShulzs} alt="" width="783" height="658" srcSet={`${withAssetPrefix('images/shulzs-e1563383994314.png')} 783w, ${withAssetPrefix('images/shulzs-e1563383994314-768x645.png')} 768w, ${withAssetPrefix('images/shulzs-e1563383994314-624x524.png')} 624w`} sizes="(max-width: 783px) 100vw, 783px" /></div>
                    <div className="col-lg-12 mt-4 mb-4"></div>
                  </div>
                </div>
              </section>
              <ul className="row icones">
                <li className="col-lg-4 col-md-6 col-12">
                  <figure className="alturaFig"><img className="alignnone size-full" style={{ width: 'auto' }} src={ImgTimerr} alt="" width="56" height="47" /></figure>
                  <h2>{intl.formatMessage({ id: 'Atualizado' })}</h2>
                  <div className="valor">
                    <p>{intl.formatMessage({ id: 'O catálogo está sempre atualizado com os novos produtos cadastrados no Catálogo Eletrônico' })}.</p>
                  </div>
                </li>
                <li className="col-lg-4 col-md-6 col-12">
                  <figure className="alturaFig"><img className="alignnone wp-image-491" style={{ width: 'auto' }} src={ImgSpeed} alt="" width="51" height="43" /></figure>
                  <h2>{intl.formatMessage({ id: 'Agilidade' })}</h2>
                  <div className="valor">
                    <p>{intl.formatMessage({ id: 'Com o uso da nossa ferramenta não demora mais que alguns minutinhos para gerar o seu catálogo inteiro' })}.</p>
                  </div>
                </li>
                <li className="col-lg-4 col-md-6 col-12">
                  <figure className="alturaFig"><img className="alignnone size-full wp-image-680" style={{ width: 'auto' }} src={ImgBook} alt="" width="56" height="47" /></figure>
                  <h2>{intl.formatMessage({ id: 'Catálogo parcial' })}</h2>
                  <div className="valor">
                    <p>{intl.formatMessage({ id: 'É possível gerar o catálogo apenas com os itens que interessa utilizando filtros de pesquisa' })}<br />
                      {intl.formatMessage({ id: 'como montadoras, linhas de produtos, etc' })}.</p>
                  </div>
                </li>
                <li className="col-lg-4 col-md-6 col-12">
                  <figure className="alturaFig"><img className="alignnone size-full wp-image-683" style={{ width: 'auto' }} src={ImgCorte} alt="" width="47" height="56" /></figure>
                  <h2>{intl.formatMessage({ id: 'Padrão gráfica' })}</h2>
                  <div className="valor">
                    <p>{intl.formatMessage({ id: 'O arquivo já é gerado com a “margem de corte” que é exigida pelas gráficas' })}.</p>
                  </div>
                </li>
                <li className="col-lg-4 col-md-6 col-12">
                  <figure className="alturaFig"><img className="alignnone size-full wp-image-485" style={{ width: 'auto' }} src={ImgBrowser} alt="" width="56" height="47" /></figure>
                  <h2>{intl.formatMessage({ id: 'Layout' })}</h2>
                  <div className="valor">
                    <p>{intl.formatMessage({ id: 'Criamos um layout exclusivo para sua empresa ou usamos o layout criado por sua agência' })}.</p>
                  </div>
                </li>
                <li className="col-lg-4 col-md-6 col-12">
                  <figure className="alturaFig"><img className="alignnone size-full wp-image-685" style={{ width: 'auto' }} src={ImgPdf} alt="" width="56" height="47" /></figure>
                  <h2>{intl.formatMessage({ id: 'Formato do catálogo' })}</h2>
                  <div className="valor">
                    <p>{intl.formatMessage({ id: 'O formato do catálogo gerado é em PDF com alta resolução, margens e sangria' })}.</p>
                  </div>
                </li>
              </ul>
              <div className="row">
                <div className="col-lg-6">
                  <h3>{intl.formatMessage({ id: 'Como funciona?' })}</h3>
                  <div className="mb-3">
                    <p>{intl.formatMessage({ id: 'Através do Software de Manutenção e do Catálogo (opcional) poderá ser gerado um PDF (Catálogo Impresso) com as informações dos produtos cadastrados no catálogo;' })}</p>
                    <p>{intl.formatMessage({ id: 'O Catálogo Impresso poderá ter capa, contracapa e lâminas intermediárias;' })}</p>
                    <p>{intl.formatMessage({ id: 'Será permitido a impressão parcial do catálogo (apenas com os produtos filtrados) ou a impressão do catálogo completo;' })}</p>
                    <p>{intl.formatMessage({ id: 'A impressão poderá ser disponibilizada na Manutenção e/ou no Catálogo;' })}</p>
                    <p>{intl.formatMessage({ id: 'O “layout” da impressão com capas (frente e atrás) poderá ser desenvolvido pela Ideia 2001 ou pela sua empresa' })}.</p>
                  </div>
                </div>
                <div className="col-lg-6 imagemMockUp"><img className="alignnone wp-image-494 size-full" src={ImgCatImpresso} alt="" width="541" height="482" /></div>
              </div>
            </>
          )}
        />
      </div>
    </Layout>
  );
};
